import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'
import library from "../../../assets/CampuLifeImages/library.JPG"


const Library = () => {
  const libraryData = {
    img: library,
    content: "The Noorul Islam College of Arts & Science Library offers a well-equipped and resource-rich environment designed to support the academic, research, and professional development needs of students, faculty, and researchers. Our collection includes a wide range of books, journals, periodicals, and digital resources across various disciplines relevant to the institute's focus areas. The library provides access to online databases, research papers, and reference materials, along with quiet study areas  for seamless learning and research. Library staff are available to assist users with research queries and information retrieval. The facility is open during regular working hours, with extended access during examination and research periods."
  }

  return (
    <>
      <div>
        <Header />
        <div className='campusmaincontainer'>
        <div className='campus-container'>
       <CampusSlashTitle slashTitle="Library" />
      <CampusDynamicSection data={libraryData} />
      </div>
      <Footer />
      </div>
      </div>
    </>
  )
}

export default Library
